import React from "react"
import { useSelector } from "react-redux"
import { Route, Switch, useRouteMatch } from "react-router-dom"
import * as routes from "../../../library/constants/routes"
import VerticalMenu from "../../../components/ui/verticalMenu/verticalMenu"
import KnowmapTeacherKnowmix from "./subpages/knowmix/knowmapTeacherKnowmix"
import KnowmapLearnerKnowmix from "./subpages/knowmix/knowmapLearnerKnowmix"
import KnowmapLearnerKnowcred from "./subpages/knowcred/knowmapLearnerKnowcred"
import KnowmapTeacherKnowcred from "./subpages/knowcred/knowmapTeacherKnowcred"
import KnowmapTeacherKnowmixKnowmeets from "./subpages/uknow/knowmapTeacherKnowmixKnowmeets"
import KnowmapLearnerKnowmixKnowmeets from "./subpages/uknow/knowmapLearnerKnowmixKnowmeets"
import KnowmapLearnerKnowmixSteps from "./subpages/knowmix/knowmapLearnerKnowmixSteps"
import KnowmapTeacherKnowmixSteps from "./subpages/knowmix/knowmapTeacherKnowmixSteps"
import ManagedMeets from "./subpages/meets/ManagedMeets"
import IncomingMeets from "./subpages/meets/IncomingMeets"
import IncomingBookings from "./subpages/bookings/IncomingBookings"
import OutgoingBookings from "./subpages/bookings/OutgoingBookings"

const KnowMap = () => {
  const { role } = useSelector(({ auth }) => auth.userData)
  const { path } = useRouteMatch()

  const menuItems = [
    {
      path: routes.KNOWMAP_INCOMING_APPOINTMENT_BOOKINGS,
      label: "Appointment bookings",
      type: "parent",
      markAsActive: false,
    },
    {
      path: routes.KNOWMAP_INCOMING_APPOINTMENT_BOOKINGS,
      label: "Incoming",
      type: "child",
      key: "incoming-booking",
    },
    {
      path: routes.KNOWMAP_OUTGOING_APPOINTMENT_BOOKINGS,
      label: "Outgoing",
      type: "child",
    },
    role !== 4 && {
      path: routes.KNOWMAP_INCOMING_MEETS,
      label: "Meets",
      type: "parent",
      markAsActive: false,
    },
    role !== 4 && {
      path: routes.KNOWMAP_INCOMING_MEETS,
      label: "Incoming",
      type: "child",
      key: "incoming-meet",
    },
    role !== 4 && {
      path: routes.KNOWMAP_MEETS,
      label: "Managed",
      type: "child",
    },
    role !== 4 && {
      path: routes.KNOWMAP_UKNOW_KNOWMIX,
      label: "Courses managed Meets",
    },
    role !== 4 && {
      path: routes.KNOWMAP_KNOWMIX,
      label: "Course grading",
      type: "parent",
      markAsActive: false,
    },
    role !== 4 && {
      path: routes.KNOWMAP_KNOWMIX,
      label: "Whole course",
      type: "child",
    },
    role !== 4 && {
      path: routes.KNOWMAP_KNOWMIX_STEPS,
      label: "Steps grading",
      type: "child",
    },
    role !== 4 && {
      path:
        role === 1 ? routes.KNOWMAP_KNOWCRED_VALID : routes.KNOWMAP_KNOWCRED,
      label: "Creds",
    },
  ].filter(Boolean)

  return (
    <div className="common-page__content">
      <main className="common-page__main">
        <Switch>
          {/*<Route*/}
          {/*  exact*/}
          {/*  path={routes.KNOWMAP_UKNOW}*/}
          {/*  component={*/}
          {/*    role === 1 ? KnowmapLearnerKnowmeets : KnowmapTeacherUknow*/}
          {/*  }*/}
          {/*/>*/}
          {/*<Route*/}
          {/*  exact*/}
          {/*  path={routes.KNOWMAP_UKNOW_STEPS}*/}
          {/*  component={*/}
          {/*    role === 1 ? KnowmapLearnerKnowmeets : KnowmapTeacherUknow*/}
          {/*  }*/}
          {/*/>*/}
          <Route
            exact
            path={[
              routes.KNOWMAP_INCOMING_APPOINTMENT_BOOKINGS,
              routes.INCOMING_SOLICIT_APPOINTMENT_AUTHORIZED,
            ]}
            component={IncomingBookings}
          />
          <Route
            exact
            path={routes.KNOWMAP_OUTGOING_APPOINTMENT_BOOKINGS}
            component={OutgoingBookings}
          />
          <Route exact path={[routes.KNOWMAP_MEETS]} component={ManagedMeets} />
          <Route
            exact
            path={[routes.KNOWMAP_INCOMING_MEETS, routes.KNOWMAP_INCOMING_MEET]}
            component={IncomingMeets}
          />
          <Route
            exact
            path={[
              routes.KNOWMAP_UKNOW_KNOWMIX,
              routes.KNOWMAP_INCOMING_KNOWMEET,
            ]}
            component={
              role === 1
                ? KnowmapLearnerKnowmixKnowmeets
                : KnowmapTeacherKnowmixKnowmeets
            }
          />
          {/*<Route*/}
          {/*  exact*/}
          {/*  path={routes.KNOWMAP_INCOMING_KNOWMEET}*/}
          {/*  component={KnowmapLearnerKnowmixKnowmeets}*/}
          {/*/>*/}
          <Route
            exact
            path={routes.KNOWMAP_KNOWMIX}
            component={
              role === 1 ? KnowmapLearnerKnowmix : KnowmapTeacherKnowmix
            }
          />
          <Route
            exact
            path={routes.KNOWMAP_KNOWMIX_STEPS}
            component={
              role === 1
                ? KnowmapLearnerKnowmixSteps
                : KnowmapTeacherKnowmixSteps
            }
          />
          <Route
            exact
            path={routes.KNOWMAP_KNOWCRED}
            component={KnowmapTeacherKnowcred}
          />
          <Route
            exact
            path={[
              routes.KNOWMAP_KNOWCRED_AWARDED,
              routes.KNOWMAP_KNOWCRED_VALID,
            ]}
            component={KnowmapLearnerKnowcred}
          />
        </Switch>
      </main>
      <aside className="common-page__sidebar">
        <VerticalMenu menuItems={menuItems} />
      </aside>
    </div>
  )
}

export default KnowMap
